import { render, staticRenderFns } from "./AdminResellerAdmin.vue?vue&type=template&id=24b33cf8"
import script from "./AdminResellerAdmin.vue?vue&type=script&lang=js"
export * from "./AdminResellerAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports